// extracted by mini-css-extract-plugin
export default {"labelText":"LocationCard_labelText__tJZcb","detailText":"LocationCard_detailText__PxCWD"};